<template lang="pug">
.form-temporaryStock(:class="{'inside-padding': !fillData}")
  h2.title {{ title }}
  .center
    shActionButton(:action="toggleQRScanner" :text="qrScannerActive ? 'Detener Escáner QR' : 'Activar Escáner QR'" :textRunning="qrScannerActive ? 'Deteniendo...' : 'Activando...'")
    .qr-scanner-container(v-if="qrScannerActive")
      #qr-reader.qr-reader
  .input-container
    input.input(v-model.number="quantity" type="number" @keydown.enter="processCode()" autocomplete="ño")
    label.label(:class="{ show: quantity }") Cantidad
  .input-container
    input.input(v-model="code" @keydown.enter="processCode()" autocomplete="ño")
    label.label(:class="{ show: code }") Ingresar Código
  .center
    div Nivel Actual:
      span.uppercase  {{ currentTier }}
    div Total Artículos: {{ totalProducts }}

  .products-container-temporary
    .product-container.data(v-for="(item, product) in stock" :class="{first: product === currentProduct }")
      .title-product-temporary
        h3.uppercase.title-product(:class="{'color-red': existsProducts[product] !== true}") {{ product }}
        shActionButton(:action="deleteProduct" :params="[product]" text="Eliminar" textRunning="Eliminando" :mini="true")
        shActionButton(:action="getOneStock" :params="[product]" text="Obtener Stock" textRunning="ObteniendoStock" :mini="true" textConfirmation="Eliminaras los datos actuales y se cambiaron por los que hay en inventario.")
      img.image-product-temporary(:src="images[product]" v-if="images[product]")
      .sizes-container(v-for="(size, index) in item.sizes")
        div.size-container
          .tiers-container
            h5.title-tier
              span Talla:
              span.uppercase  {{ size }} ({{item.quantity[index]}}){{ ':' }}
            //@click="deleteTier(product, index, indexT)"
            .tier-container-x(v-for="(tier, indexT) in item.tiers[index]")
              shActionButton(:action="deleteTier" :params="[product, index, indexT]" :text="tier" :textRunning="tier" :mini="true" :class="{'color-red': existsTiers[tier] !== true}")

              // .input-container
                label.label tier
                select.select(v-model="stock[product].tiers[index][indexT]" autocomplete="ño" required)
                  option(v-for="tier in tiers" :value="tier")

          form.container-change-all(@submit.prevent="")
            .input-container.arrow.input-container-change-all
              select.select(v-model="tierGlobal" autocomplete="ño" required)
                option(v-for="tier in tiers" :value="tier") {{ tier }}
              label.label(:class="{ show: tierGlobal }") Elegir Nivel
            shActionButton(:isForm="true" :action="changeAllTiers" :params="[stock[product].tiers[index]]" text="Cambiar Niveles" textRunning="Cambiando" :mini="true" :normalColor="true")

  .divider

  // .center
    div Errores de Niveles
    .errors-data
      div(v-for="(exists, tier, index) in existsTiers" v-if="!exists")
        span {{ tier }}
        div {{ ' - ' }}

    .divider

    div Errores de Products
    span(v-for="(exists, product) in existsProducts" v-if="!exists") {{ product }}

    .divider

    div Errores de Tallas
    span(v-for="(exists, size) in existsSizes" v-if="!exists") {{ size }}

  form.center(@submit.prevent="" autocomplete="off")
    .input-container
      label.label
        shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="temporaryStock" title="Temporary Stock Name")
      input.input(v-model="dataForm.temporaryStock" autocomplete="ño" :disabled="fillData" required)

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  div
    // .right.x
      shActionButton(:action="getStock" text="Obtener Inventario" textRunning="Obteniendo Inventario" textConfirmation="Se va a obtener todo el inventario actual y se va a eliminar los datos que tengas actualmente en pantalla.")
    .left.x
      shActionButton(:action="addStock" text="Agregar Stock" textRunning="Agregando Stock" textConfirmation="Se va a agregar los productos actuales al inventario existente.")
    .left.x
      shActionButton(:action="subtractStock" text="Restar Stock" textRunning="Restando Stock" textConfirmation="Se va a restar los productos actuales al inventario existente.")
    // .left.x
      shActionButton(:action="updateStock" text="Actualizar Stock" textRunning="Actualizando Stock" textConfirmation="Se va a reemplazar el inventario total con los datos que tienes en este pantalla.")
    .right(v-if="fillData")
      shActionButton(:action="deleteTemporaryStock" text="Eliminar X" textRunning="Eliminando X" textConfirmation="Se va eliminar este inventario temporal.")

  .center(v-if="report.length")
    h3 Reporte
    div(v-for="item in report")
      h4(:class="{'color-red': !item.success}") {{ item.product }}
      div(:class="{'color-red': !item.success}") Exitoso: {{ item.success}}
      div(v-if="item.error") Error: {{ item.error }}
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import mDB from '@/mixins/db'
import gql from '@my/graphql'
import gqlTemporaryStock from '@/graphql/temporaryStock'
import gqlTier from '@/graphql/tier'
import gqlSize from '@/graphql/size'
import gqlProduct from '@/graphql/product'
import gqlStock from '@/graphql/stock'
import shInputList from '@/components/elements/InputList'
import { Html5Qrcode } from 'html5-qrcode'
import { normalizeScanCode, stripScanPrefix } from '@/helpers/scanCode'

export default {
  name: 'FormTemporaryStock',

  mixins: [mForm, mFilters, mDB],

  components: { shInputList },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      stock: {},
      existsTiers: {},
      existsProducts: {},
      existsSizes: {},
      code: '',
      currentTier: '',
      sounds: {
        beepError: 'beep_error.mp3',
        beep: 'beep.mp3',
        error: 'error.mp3',
        tier: 'tier.mp3',
        product: 'product.mp3'
      },
      audios: {
        beepError: '',
        beep: '',
        error: '',
        tier: '',
        product: ''
      },
      dataForm: {
        temporaryStock: '',
        stringStock: '',
        stringExistsTiers: '',
        stringExistsProducts: '',
        stringExistsSizes: ''
      },
      report: [],
      tierGlobal: '',
      resolver: 'temporaryStock',
      key: 'temporaryStock',
      gql: gqlTemporaryStock,
      camera: 'auto',
      torchActive: false,
      currentProduct: '',
      qrScannerActive: false,
      html5QrCode: null,
      lastScannedCode: '',
      lastScanTime: 0,
      quantity: 1,
      sizes: {
        xs: '26',
        s: '28',
        m: '30',
        l: '32',
        xl: '34',
        xxl: '36'
      },
      images: {}
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
    this.parseJSONObjects()
  },

  mounted () {
    for (const sound in this.sounds) {
      this.audios[sound] = new Audio(`${this.soundPath}/${this.sounds[sound]}`)
    }
  },

  methods: {
    fixCodeJogger (code) {
      if (!code) return code
      code = normalizeScanCode(code)
      const isJogger = code.slice(0, 2) === 'hj'

      if (!isJogger) return code

      const codeArray = code.split('-')
      const reference = codeArray[0]
      const size = codeArray[1]

      if (!reference || !size) return code

      const sizeFixed = this.sizes[size]

      if (!sizeFixed) return code

      return `${reference}-${sizeFixed}`
    },

    sendForm () {
      const existsErrors = this.existsErrors()

      if (existsErrors) {
        this.showMessage({ message: 'Hay un error en el stock, revisa los errores e intenta de nuevo', type: 'error' })
      } else {
        this.stringifyObjects()

        if (!this.fillData) {
          this.newTemporaryStock()
        } else {
          this.updateTemporaryStock()
        }

        this.clearObjects()
      }
    },

    existsErrors () {
      for (const product in this.existsProducts) {
        const existsProduct = this.existsProducts[product]

        if (this.stock[product] === undefined) {
          this.$delete(this.existsProducts, product)
        } else {
          if (existsProduct !== true) return true
        }
      }

      for (const size in this.existsSizes) {
        const existsSize = this.existsSizes[size]

        if (existsSize !== true) {
          let existsSizeProduct = false

          for (const product in this.stock) {
            const sizes = this.stock[product].sizes
            const position = sizes.indexOf(size)

            if (position >= 0) {
              existsSizeProduct = true
              break
            }
          }

          if (!existsSizeProduct) {
            this.$delete(this.existsSizes, size)
          } else {
            return true
          }
        }
      }

      for (const tier in this.existsTiers) {
        const existsTier = this.existsTiers[tier]

        if (existsTier !== true) {
          let existsTierProduct = false

          for (const product in this.stock) {
            const tiers = this.stock[product].tiers
            const allTiers = tiers.reduce((acumulatorArray, currentArray) => acumulatorArray.concat(currentArray), [])
            const position = allTiers.indexOf(tier)

            if (position >= 0) {
              existsTierProduct = true
              break
            }
          }

          if (!existsTierProduct) {
            this.$delete(this.existsTiers, tier)
          } else {
            return true
          }
        }
      }

      return false
    },

    newTemporaryStock () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateTemporaryStock () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteTemporaryStock () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    stringifyObjects () {
      this.dataForm.stringStock = JSON.stringify(this.stock)
      this.dataForm.stringExistsTiers = JSON.stringify(this.existsTiers)
      this.dataForm.stringExistsProducts = JSON.stringify(this.existsProducts)
      this.dataForm.stringExistsSizes = JSON.stringify(this.existsSizes)
    },

    parseJSONObjects () {
      this.stock = this.dataForm.stringStock ? JSON.parse(this.dataForm.stringStock) : {}
      this.existsTiers = this.dataForm.stringExistsTiers ? JSON.parse(this.dataForm.stringExistsTiers) : {}
      this.existsSizes = this.dataForm.stringExistsSizes ? JSON.parse(this.dataForm.stringExistsSizes) : {}
      this.existsProducts = this.dataForm.stringExistsProducts ? JSON.parse(this.dataForm.stringExistsProducts) : {}
    },

    clearObjects () {
      if (!this.fillData) {
        this.stock = {}
        this.existsTiers = {}
        this.existsProducts = {}
        this.existsSizes = {}
      }
    },

    async processCode () {
      const code = this.fixCodeJogger(this.code)
      const tier = this.currentTier.toLowerCase().trim()

      if (!code) {
        this.playSoundError()
        return
      }

      if (code[0] === '-') {
        const tier = stripScanPrefix(code)
        if (tier) {
          const existsTier = await this.existsTier(tier)
          if (!existsTier) {
            this.showMessage({ message: `No existe el nivel ${tier}, crealo en el sistema y vuelve a intentar`, type: 'error' })
            this.playSoundError()
          } else {
            this.setTier(tier)
          }
        } else {
          this.playSoundError()
        }
      } else {
        const productSplit = code.split('-')

        if (productSplit.length !== 2) {
          this.playSoundError()
        } else {
          const nameProduct = productSplit[0]
          const size = productSplit[1]

          if (nameProduct && size && tier) {
            this.currentProduct = nameProduct
            this.enterProduct(nameProduct.toLowerCase(), size.toLowerCase(), tier.toLowerCase(), this.quantity)
            this.quantity = 1
          } else {
            this.playSoundError()
          }
        }
      }

      this.code = ''
    },

    setTier (tier) {
      this.currentTier = tier
      this.playSoundTier()
    },

    existsProduct (product) {
      return this.existsElement(gqlProduct.EXISTS_PRODUCT, { product }, this.existsProducts, product, 'existsProduct')
    },

    async getProductImage (product) {
      if (!product) return
      const query = gqlProduct.GET_BY_PRODUCT

      const response = await gql.query(query, { product }, false)

      if (!response) return
      if (!response.data || !response.data.getByProduct) return

      const productFind = response.data.getByProduct

      if (!productFind.images || !productFind.images.length) return

      return this.getImageURL(productFind)
    },

    getImageURL (product) {
      return `${this.imagePath}/${product.brand}/${product.folder}/${product.subfolder}/${product.images[0]}`
    },

    async existsTier (tier) {
      return this.existsElement(gqlTier.EXISTS_TIER, { tier }, this.existsTiers, tier, 'existsTier')
    },

    existsSize (size) {
      return this.existsElement(gqlSize.EXISTS_SIZE, { size }, this.existsSizes, size, 'existsSize')
    },

    async existsElement (query, options, existsElements, element, resolver) {
      if (existsElements[element] === undefined) {
        const response = await gql.query(query, options)

        if (!response) {
          // this.$set(existsElements, element, 'error')
        } else {
          if (response.data === undefined || response.data[resolver] === undefined) {
            // this.$set(existsElements, element, 'error')
          } else {
            this.$set(existsElements, element, response.data[resolver])
            return response.data[resolver]
          }
        }
      } else if (existsElements[element] === false) {
        return false
      } else {
        return true
      }
    },

    async enterProduct (nameProduct, size, tier, quantity) {
      const stock = this.stock

      const existsTier = await this.existsTier(tier)
      if (!existsTier) {
        this.showMessage({ message: `No existe el nivel ${tier}, crealo en el sistema y vuelve a intentar`, type: 'error' })
        this.playSoundError()
        return
      }

      const existsProduct = await this.existsProduct(nameProduct)
      if (!existsProduct) {
        this.showMessage({ message: `No existe el product ${nameProduct}, crealo en el sistema y vuelve a intentar`, type: 'error' })
        this.playSoundError()
        return
      }

      const existsSize = await this.existsSize(size)
      if (!existsSize) {
        this.showMessage({ message: `No existe la talla ${size}, creala en el sistema y vuelve a intentar`, type: 'error' })
        this.playSoundError()
        return
      }

      if (!this.images[nameProduct]) {
        const image = await this.getProductImage(nameProduct)
        if (image) this.$set(this.images, nameProduct, image)
      }

      if (!stock[nameProduct]) this.$set(stock, nameProduct, {})

      this.pushQuantity(stock[nameProduct], size, tier, quantity)
      this.playSoundProduct()
    },

    pushQuantity (product, size, tier, quantity = 1) {
      quantity = Number(quantity)

      if (isNaN(quantity)) {
        this.showMessage({ message: 'La cantidad no es válida, ingresa un número y vuelve a intentar', type: 'error' })
        this.playSoundError()
        return
      }

      if (!product.sizes) {
        this.$set(product, 'sizes', [])
        this.$set(product, 'quantity', [])
        this.$set(product, 'tiers', [])
      }

      if (product.sizes.length === 0) {
        product.sizes.push(size)
        product.quantity.push(quantity)
        product.tiers.push(Array(quantity).fill(tier))
      } else {
        const position = this.sizePosition(product.sizes, size)

        if (position < 0) {
          product.sizes.push(size)
          product.quantity.push(quantity)
          product.tiers.push(Array(quantity).fill(tier))
        } else {
          const previusQuantity = Number(product.quantity[position]) || 0
          const previusTier = product.tiers[position] || []

          this.$set(product.quantity, position, previusQuantity + quantity)
          this.$set(product.tiers, position, previusTier.concat(Array(quantity).fill(tier)))
        }
      }

      console.log(product.tiers)
    },

    sizePosition (sizes, size) {
      return sizes.findIndex(element => element === size)
    },

    playSoundTier () {
      if (!this.audios.beep) {
        this.audios.beep = this.playSound(this.sounds.beep)
      } else {
        this.audios.beep.play()
      }

      if (!this.audios.tier) {
        this.audios.tier = this.playSound(this.sounds.tier)
      } else {
        this.audios.tier.play()
      }
    },

    playSoundProduct (sound) {
      if (!this.audios.beep) {
        this.audios.beep = this.playSound(this.sounds.beep)
      } else {
        this.audios.beep.play()
      }

      if (!this.audios.product) {
        this.audios.product = this.playSound(this.sounds.product)
      } else {
        this.audios.product.play()
      }
    },

    playSoundError () {
      if (!this.audios.beepError) {
        this.audios.beepError = this.playSound(this.sounds.beepError)
      } else {
        this.audios.beepError.play()
      }

      if (!this.audios.error) {
        this.audios.error = this.playSound(this.sounds.error)
      } else {
        this.audios.error.play()
      }
    },

    deleteTier (productName, index, indexTier) {
      const product = this.stock[productName]

      if (product) {
        const previusQuantity = product.quantity[index]

        if (previusQuantity - 1 === 0) {
          product.sizes.splice(index, 1)
          product.quantity.splice(index, 1)
          product.tiers.splice(index, 1)
        } else {
          this.$set(product.quantity, index, previusQuantity - 1)
          product.tiers[index].splice(indexTier, 1)
        }
      }
    },

    deleteProduct (productName) {
      this.$delete(this.stock, productName)
    },

    convertStockToArray () {
      let arrayStock = []

      for (const productName in this.stock) {
        const product = this.stock[productName]
        arrayStock.push({
          product: productName,
          sizes: product.sizes,
          tiers: product.tiers,
          quantity: product.quantity
        })
      }

      return arrayStock
    },

    async updateStock () {
      this.showLoader('Updating stock, please', 'happy', true)
      this.report = []
      const stock = this.convertStockToArray()
      const mutation = gqlStock.UPDATE
      const options = { input: stock }

      const response = await gql.mutate(mutation, options, true)

      if (!response) {
        this.showMessage({ message: 'Error desconocido al actualizar el stock', type: 'error' })
      } else {
        if (!response.data || !response.data.updateStock) {
          this.showMessage({ message: 'Error desconocido al actualizar el stock', type: 'error' })
        } else {
          this.showMessage({ message: 'La actualización ha terminado' })
          this.report = response.data.updateStock
        }
      }
    },
    async addStock () {
      this.showLoader('Updating stock, please', 'happy', true)
      this.report = []
      const stock = this.convertStockToArray()
      const mutation = gqlStock.ADD
      const options = { input: stock }

      const response = await gql.mutate(mutation, options, true)

      if (!response) {
        this.showMessage({ message: 'Error desconocido al agregar al stock', type: 'error' })
      } else {
        if (!response.data || !response.data.addStock) {
          this.showMessage({ message: 'Error desconocido al agregar al stock', type: 'error' })
        } else {
          this.showMessage({ message: 'La suma de productos al stock ha finalizado' })
          this.report = response.data.addStock
        }
      }
    },
    async subtractStock () {
      this.showLoader('Updating stock, please', 'happy', true)
      this.report = []
      const stock = this.convertStockToArray()
      const mutation = gqlStock.SUBTRACT
      const options = { input: stock }

      const response = await gql.mutate(mutation, options, true)

      if (!response) {
        this.showMessage({ message: 'Error desconocido al restar del stock', type: 'error' })
      } else {
        if (!response.data || !response.data.subtractStock) {
          this.showMessage({ message: 'Error desconocido al restar del stock', type: 'error' })
        } else {
          this.showMessage({ message: 'La resta de productos del stock ha terminado' })
          this.report = response.data.subtractStock
        }
      }
    },

    async getStock () {
      this.showLoader('Getting stock, please wait...', 'happy', true)

      const query = gqlStock.GET
      const response = await gql.query(query)

      if (!response) {
        this.showMessage({ message: 'Error desconocido al obtener el stock', type: 'error' })
      } else {
        if (!response.data || !response.data.getStock) {
          this.showMessage({ message: 'Error desconocido al obtener el stock', type: 'error' })
        } else {
          this.showMessage({ message: 'El stock se ha obtenido correctamente' })
          const stock = response.data.getStock
          this.saveStock(stock)
        }
      }
    },

    async getOneStock (productName) {
      const query = gqlStock.GET_ONE
      const options = { product: productName }
      const response = await gql.query(query, options)

      if (!response) {
        this.showMessage({ message: `Error desconocido al obtener el stock del producto ${productName}`, type: 'error' })
      } else {
        if (!response.data || !response.data.getOneStock) {
          this.showMessage({ message: `Error desconocido al obtener el stock del producto ${productName}`, type: 'error' })
        } else {
          this.showMessage({ message: `El stock del producto ${productName} fue obtenido` })
          const stock = response.data.getOneStock
          this.saveStock([stock])
        }
      }
    },

    saveStock (stock) {
      if (stock && stock.length) {
        stock.forEach(product => {
          const productName = product.product
          this.stock[productName] = {}
          this.$set(this.stock[productName], 'tiers', product.tiers || [])
          this.$set(this.stock[productName], 'sizes', product.sizes || [])
          const quantities = (product.quantityAvailable || []).map(q => Number(q))
          this.$set(this.stock[productName], 'quantity', quantities)
          this.$set(this.existsProducts, productName, true)

          const sizes = product.sizes

          sizes.forEach(size => {
            this.$set(this.existsSizes, size, true)
          })

          const tiers = product.tiers.reduce((tiersAcumulator, currentTier) => {
            return tiersAcumulator.concat(currentTier)
          }, [])

          tiers.forEach(tier => {
            this.$set(this.existsTier, tier, true)
          })
        })
      }
    },

    changeAllTiers (array) {
      if (!this.tierGlobal) return

      array.forEach((_, index) => {
        this.$set(array, index, this.tierGlobal)
      })
    },

    onDecode (code) {
      this.code = code
      try {
        this.processCode()
      } catch (error) {
        console.log(error.message)
      }
      this.camera = 'off'
      setTimeout(() => {
        this.camera = 'auto'
      }, 100)
    },

    async toggleQRScanner () {
      if (this.qrScannerActive) {
        await this.stopQRScanner()
      } else {
        await this.startQRScanner()
      }
    },

    async startQRScanner () {
      try {
        // Verificar si hay soporte para getUserMedia
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          this.showMessage({
            message: 'Tu navegador no soporta el acceso a la cámara. Por favor usa Chrome, Firefox o Safari.',
            type: 'error'
          })
          return
        }

        // Primero activar el estado para que Vue renderice el elemento
        this.qrScannerActive = true

        // Esperar a que Vue renderice el elemento en el DOM
        await this.$nextTick()

        // Dar un pequeño delay adicional para asegurar que el elemento esté completamente renderizado
        await new Promise(resolve => setTimeout(resolve, 200))

        const qrReaderElement = document.getElementById('qr-reader')
        if (!qrReaderElement) {
          this.qrScannerActive = false
          this.showMessage({
            message: 'Error: No se pudo encontrar el elemento del escáner. Por favor recarga la página.',
            type: 'error'
          })
          return
        }

        this.html5QrCode = new Html5Qrcode('qr-reader')

        const config = {
          fps: 10,
          qrbox: { width: 250, height: 250 },
          aspectRatio: 1.0,
          disableFlip: false
        }

        // Intentar diferentes configuraciones de cámara
        const cameraConfigs = [
          { facingMode: 'environment' }, // Cámara trasera
          { facingMode: 'user' }, // Cámara frontal
          { facingMode: { exact: 'environment' } },
          { facingMode: { exact: 'user' } }
        ]

        let cameraStarted = false
        let lastError = null

        for (const cameraConfig of cameraConfigs) {
          try {
            await this.html5QrCode.start(
              cameraConfig,
              config,
              (decodedText, decodedResult) => {
                this.onQRCodeScanned(decodedText)
              },
              (errorMessage) => {
                // Ignorar errores de escaneo continuo (no hay QR visible)
              }
            )
            cameraStarted = true
            break
          } catch (err) {
            lastError = err
            console.log(`Intento de cámara falló con config:`, cameraConfig, err.message)
            // Si falla, intentar con la siguiente configuración
            continue
          }
        }

        if (!cameraStarted) {
          // Si todas las configuraciones fallaron, intentar sin especificar cámara
          try {
            await this.html5QrCode.start(
              undefined, // Dejar que el navegador elija
              config,
              (decodedText, decodedResult) => {
                this.onQRCodeScanned(decodedText)
              },
              (errorMessage) => {
                // Ignorar errores de escaneo continuo
              }
            )
            cameraStarted = true
          } catch (finalErr) {
            lastError = finalErr
          }
        }

        if (cameraStarted) {
          this.showMessage({
            message: 'Escáner QR activado. Apunta la cámara al código QR.',
            type: 'success'
          })
        } else {
          // Si falló, desactivar el estado para ocultar el elemento
          this.qrScannerActive = false
          const errorMsg = (lastError && lastError.message) || (lastError && lastError.toString()) || 'Error desconocido'
          console.error('Error al iniciar el escáner QR:', lastError)
          console.error('Detalles del error:', {
            name: lastError && lastError.name,
            message: errorMsg,
            stack: lastError && lastError.stack
          })

          let userMessage = 'Error al iniciar la cámara. '

          if (errorMsg.includes('Permission denied') || errorMsg.includes('NotAllowedError')) {
            userMessage += 'Por favor, permite el acceso a la cámara en la configuración de tu navegador.'
          } else if (errorMsg.includes('NotFoundError') || errorMsg.includes('No camera')) {
            userMessage += 'No se encontró ninguna cámara disponible.'
          } else if (errorMsg.includes('NotReadableError') || errorMsg.includes('TrackStartError')) {
            userMessage += 'La cámara está siendo usada por otra aplicación. Cierra otras aplicaciones que usen la cámara.'
          } else {
            userMessage += 'Asegúrate de dar permisos de cámara y que no esté siendo usada por otra aplicación.'
          }

          this.showMessage({
            message: userMessage,
            type: 'error'
          })

          // Limpiar en caso de error
          if (this.html5QrCode) {
            try {
              await this.html5QrCode.clear()
            } catch (e) {
              // Ignorar errores al limpiar
            }
            this.html5QrCode = null
          }
        }
      } catch (err) {
        console.error('Error inesperado al iniciar el escáner QR:', err)
        this.showMessage({
          message: 'Error inesperado al iniciar la cámara. Por favor intenta de nuevo.',
          type: 'error'
        })

        if (this.html5QrCode) {
          try {
            await this.html5QrCode.clear()
          } catch (e) {
            // Ignorar errores al limpiar
          }
          this.html5QrCode = null
        }
      }
    },

    async stopQRScanner () {
      try {
        if (this.html5QrCode) {
          try {
            await this.html5QrCode.stop().catch(err => {
              console.warn('Error al detener el escáner (puede que ya esté detenido):', err)
            })
          } catch (err) {
            console.warn('Error al detener el escáner:', err)
          }

          try {
            await this.html5QrCode.clear()
          } catch (err) {
            console.warn('Error al limpiar el escáner:', err)
          }

          this.html5QrCode = null
        }
        this.qrScannerActive = false
      } catch (err) {
        console.error('Error al detener el escáner QR:', err)
        this.qrScannerActive = false
        this.html5QrCode = null
      }
    },

    onQRCodeScanned (code) {
      const now = Date.now()
      const timeSinceLastScan = now - this.lastScanTime

      // Evitar procesar el mismo código múltiples veces en menos de 1 segundo
      if (code === this.lastScannedCode && timeSinceLastScan < 1000) {
        return
      }

      // Actualizar el último código escaneado y tiempo
      this.lastScannedCode = code
      this.lastScanTime = now

      // Reproducir sonido de escaneo
      this.playSoundProduct()

      // Procesar el código escaneado
      this.code = code
      this.processCode()
    }
  },

  computed: {
    totalProducts () {
      let total = 0

      for (const key in this.stock) {
        if (Object.hasOwnProperty.call(this.stock, key)) {
          const product = this.stock[key]
          const quantity = product.quantity

          total += quantity.reduce((subtotal, element) => subtotal + element, 0)
        }
      }

      return total
    },
    tiers () {
      return this.$store.state.variables.tiers
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  },

  beforeDestroy () {
    if (this.qrScannerActive) {
      this.stopQRScanner()
    }
  }
}
</script>

<style lang="stylus">
.form-temporaryStock
  position relative

.title-size, .title-tier
  font-size 1.2em
  margin .5em 0

.title-tier
  position relative
  top -.1em
  margin-right 1em

.title-size
  margin-top 1em

.tiers-container
  display flex
  flex-wrap wrap
  align-items center

.tier-container-x
  margin 0 .25em .5em .25em
  padding-top .3em
  cursor pointer

.products-container-temporary
  display flex
  flex-direction column-reverse

.product-container-temporary h3
  margin 0

.image-product-temporary
  width 20em
  height 20em
  object-fit cover

.product-container
  margin 0

.color-red button
  color #FF5968

.x
  margin 1.5em 0

.qr-reader
  height 20em !important
  width 20em  !important
  display inline-block
  margin 1em auto

.qr-scanner-container
  margin 1em 0
  display flex
  justify-content center
  align-items center

.title-product-temporary
  display flex
  align-items center
  gap 1em
  justify-content center

.input-container-change-all
  font-size .8em
  max-width 15em

.container-change-all
  display flex
  align-items center
  gap 1em

.sizes-container
  margin 2em 0 2em 0

.first
  order: 10000
</style>



// WEBPACK FOOTER //
// src/components/pages/temporaryStock/Form.vue